export default __webpack_public_path__ + "static/0234-050bbddb442250c2a6db8592fd3eb279.png";